import React from "react";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import ADIM from "./ADIM";
import TrackTask from "./TrackTask";
import Page from "@jumbo/shared/Page";

const ADIM_Routes = [
    {
        path: ["adim","/adim/process-matter"],
        element: <TenantAdminRoute element={
            <Page component={ADIM} />
        } />
    },
    {
        path: ["/adim/track-task"],
        element: <TenantAdminRoute element={
            <Page component={TrackTask} />
        } />
    },
];
export default ADIM_Routes;